module.exports = __webpack_public_path__ + "img/parallax-text-left.9916be1b.svg";